// M11 : personnel sans paie, H6-01. Les identités et dossiers individuels sont protégés.
import { z } from 'zod';

const id = z.string().uuid();
const texte = (max: number) => z.string().trim().min(1).max(max);
const jour = z.iso.date();
export const STATUTS_AGENT = ['fonctionnaire', 'contractuel', 'journalier', 'stagiaire'] as const;
export const schemaCreationAgentPersonnel = z.strictObject({
  matricule: texte(60),
  nom: texte(120),
  prenoms: texte(160),
  statut: z.enum(STATUTS_AGENT),
  date_entree: jour,
  grade: z.string().trim().max(100).optional(),
  echelon: z.string().trim().max(100).optional(),
  appartenance_id: id.nullable().optional(),
});
export const schemaModificationAgentPersonnel = schemaCreationAgentPersonnel.partial();
export const schemaClotureAffectationPersonnel = z.strictObject({ fin: jour });
export const schemaAffectationAgentPersonnel = z
  .strictObject({
    service_id: id,
    poste: texte(160),
    debut: jour,
    fin: jour.nullable(),
  })
  .refine((v) => !v.fin || v.fin >= v.debut, { path: ['fin'], message: 'La fin précède le début' });
export const schemaContratAgentPersonnel = z
  .strictObject({
    reference: texte(100),
    nature: texte(120),
    debut: jour,
    fin: jour.nullable(),
  })
  .refine((v) => !v.fin || v.fin >= v.debut, { path: ['fin'], message: 'La fin précède le début' });
export const ETATS_PRESENCE = ['present', 'absent', 'mission', 'conge'] as const;
export const schemaPresencePersonnel = z.strictObject({
  agent_id: id,
  jour,
  etat: z.enum(ETATS_PRESENCE),
});
export const schemaFiltrePersonnel = z.strictObject({
  recherche: z.string().trim().max(100).optional(),
  service_id: id.optional(),
  limite: z.coerce.number().int().min(1).max(200).default(100),
  apres: id.optional(),
});
export const schemaFiltrePresencesPersonnel = z
  .strictObject({
    debut: jour,
    fin: jour,
    service_id: id.optional(),
    agent_id: id.optional(),
  })
  .refine((v) => v.fin >= v.debut && v.fin.slice(0, 4) === v.debut.slice(0, 4), {
    path: ['fin'],
    message: 'Choisir une période croissante dans la même année',
  });
export const schemaFormationPersonnel = z.strictObject({
  libelle: texte(200),
  organisme: texte(200),
  description: z.string().trim().max(4000),
});
export const schemaSessionFormationPersonnel = z
  .strictObject({
    formation_id: id,
    debut: jour,
    fin: jour,
    lieu: texte(250),
  })
  .refine((v) => v.fin >= v.debut, { path: ['fin'], message: 'La fin précède le début' });
export const schemaParticipationFormationPersonnel = z.strictObject({
  agent_id: id,
  etat: z.enum(['inscrit', 'present', 'absent', 'termine']),
});
export const schemaCritereEvaluationPersonnel = z.strictObject({
  code: z.string().regex(/^[a-z][a-z0-9_]{0,39}$/),
  libelle: texte(200),
  maximum: z.number().int().min(1).max(100),
});
export const schemaCampagneEvaluationPersonnel = z.strictObject({
  libelle: texte(160),
  annee: z.number().int().min(2000).max(2200),
  grille: z
    .array(schemaCritereEvaluationPersonnel)
    .min(1)
    .max(30)
    .refine((g) => new Set(g.map((c) => c.code)).size === g.length, 'Code de critère répété'),
});
export const schemaEvaluationPersonnel = z.strictObject({
  agent_id: id,
  campagne_id: id,
  notes: z.record(z.string(), z.number().finite().min(0).max(100)),
  commentaire: z.string().trim().max(8000),
});
export const schemaDocumentPersonnel = z.strictObject({
  libelle: texte(200),
  categorie: z.enum(['identite', 'contrat', 'formation', 'autre']),
});
